var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 13,
    viewBox: "0 0 19 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m.186 6.51 15.197 6.447-1.643-4.4 4.554-2.047-4.554-2.048 1.643-4.4z"
  })));
};
export default SvgArrowLeft;